import React, { useState, useEffect  } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from "react-redux";
import * as UserActions from '../../actions/UserActions'
import LoginForm from './LoginForm'
import * as Helper from '../../utils/Helper'
import Header from './parts/Header'
import Footer from '../after_login/parts/Footer'
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';

// LoginView
const LoginView = (props) => {

  let navigate = useNavigate();
  let dispatch = useDispatch();

  let [loading, setLoading] = useState(false);

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _firstScript = async () => {
    let _rtnObj = await Helper.loginWithToken()
    if (_rtnObj.status === true) {

      // update props
      dispatch(UserActions.loginWithEmail(_rtnObj.token_params))

      // redirect
      navigate("/dashboard")

    }
  }

  return (
    <div>

      <div style={{
        backgroundColor: '#008CC8',
        height: 800,
      }}>

        {/* header */}
        <Header />

        {/* login form */}
        <LoginForm setLoading={setLoading} />

      </div>

      {/* fooder */}
      <Footer />


      {/* loading */}
      <Loader fullPage={true} loading={loading} />

    </div>
  )
}

export default LoginView
